const getIdForModel = (list, modelName) => {
    if (!list) {
        return;
    }
    const currModel = list.filter((element) => {
        return element.title === modelName;
    });
    if (currModel.length === 1) {
        return currModel[0].id;
    }
    return;
};

export default getIdForModel;
